import { RootState } from '../store';

export const getHttpsProviders = (state: RootState) =>
  state.httpsProviders.httpsProviders;
export const getAllCommunityProvider = (state: RootState) =>
  state.httpsProviders.allCommunityProviders;
export const getNonApprovedProviders = (state: RootState) =>
  state.httpsProviders.nonApprovedProviders;
export const getNonActiveProviders = (state: RootState) =>
  state.httpsProviders.nonActiveProviders;
export const getSelectedProvidersFromCreateApp = (state: RootState) =>
  state.httpsProviders.selectedProvidersFromCreateApp;
export const getNavigateHistory = (state: RootState) =>
  state.httpsProviders.navigateHistory;
export const getLoading = (state: RootState) => state.httpsProviders.isLoading;
export const getApprovalPendingProviderForUser = (state: RootState) =>
  state.httpsProviders.approvalPendingProviderForUser;
